import script from "./Submit.vue?vue&type=script&lang=ts&setup=true"
export * from "./Submit.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__